export default "__VITE_ASSET__BKnE8LAR__"